<template>
    <div>
        <div id="space"></div>
    </div>
</template>

<script>
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { MTLLoader, OBJLoader } from 'three-obj-mtl-loader'

export default {
  data () {
    return {
      container: null,
      stats: null,

      camera: null,
      scene: null,
      renderer: null,
      mesh: null,

      mouseX: 0,
      mouseY: 0,

      windowHalfX: window.innerWidth / 2,
      windowHalfY: window.innerHeight / 2
    }
  },
  mounted () {
    this.init()
    this.animate()
  },
  methods: {
    init () {
      this.container = document.getElementById('space')
      this.camera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 1, 8000)
      this.camera.position.set(0, 0, 1500)

      this.scene = new THREE.Scene()

      var ambient = new THREE.AmbientLight(0xffffff)
      this.scene.add(ambient)

      var directionalLight = new THREE.DirectionalLight(0xffffff)
      directionalLight.position.set(-5, 5, 5).normalize()
      this.scene.add(directionalLight)

      var pointlight = new THREE.PointLight(0x63d5ff, 1, 200)
      pointlight.position.set(0, 0, 200)
      this.scene.add(pointlight)
      var pointlight2 = new THREE.PointLight(0xffffff, 1, 200)
      pointlight2.position.set(-200, 200, 200)
      this.scene.add(pointlight2)
      var pointlight3 = new THREE.PointLight(0xffffff, 1.5, 200)
      pointlight3.position.set(-200, 200, 0)
      this.scene.add(pointlight3)
      this.scene.add(new THREE.PointLightHelper(pointlight3))
      this.scene.add(new THREE.PointLightHelper(pointlight2))
      this.scene.add(new THREE.PointLightHelper(pointlight))

      this.createMtlObj({
        mtlBaseUrl: '../../assets/3d/海尔路站/',
        mtlPath: '../../assets/3d/海尔路站/',
        mtlFileName: '海尔路站.mtl',
        objPath: '../../assets/3d/海尔路站/',
        objFileName: '海尔路站.obj',
        completeCallback: function (object) {
          object.traverse(function (child) {
            if (child instanceof THREE.Mesh) {
              child.material.side = THREE.DoubleSide
              child.material.emissive.r = 0
              child.material.emissive.g = 0.01
              child.material.emissive.b = 0.05
              child.material.transparent = true
              // child.material.opacity=0;
              // child.material.shading=THREE.SmoothShading;
            }
          })

          object.emissive = 0x00ffff
          object.ambient = 0x00ffff
          // object.rotation.x= 10/180*Math.PI;
          object.position.y = 0
          object.position.z = 0
          object.scale.x = 1
          object.scale.y = 1
          object.scale.z = 1
          object.name = 'haven'
          object.rotation.y = -Math.PI
          this.scene.add(object)
        },
        progress: function (persent) {

        }
      })
      this.renderer = new THREE.WebGLRenderer()
      this.renderer.setPixelRatio(window.devicePixelRatio)
      this.renderer.setSize(window.innerWidth, window.innerHeight)
      this.container.appendChild(this.renderer.domElement)
      document.addEventListener('mousemove', this.onDocumentMouseMove, false)
      window.addEventListener('resize', this.onWindowResize, false)

      // 载入鼠标事件
      this.loadMouseEvent()
    },
    loadMouseEvent () {
      var controls = new OrbitControls(this.camera, this.container)
      // controls.maxPolarAngle=1.5;
      // controls.minPolarAngle=1;
      controls.enableDamping = true
      controls.enableKeys = false
      controls.enablePan = false
      controls.dampingFactor = 0.1
      controls.rotateSpeed = 0.1
      //      controls.enabled = false;
      // controls.minDistance=1000;
      // controls.maxDistance=3000;
    },
    createMtlObj (options) {
      //      options={
      //          mtlBaseUrl:"",
      //          mtlPath:"",
      //          mtlFileName:"",
      //          objPath:"",
      //          objFileName:"",
      //          completeCallback:function(object){
      //          }
      //          progress:function(persent){
      //
      //          }
      //      }
      // THREE.Loader.Handlers.add( /\.dds$/i, new THREE.DDSLoader() );
      var mtlLoader = new MTLLoader()
      mtlLoader.setBaseUrl(options.mtlBaseUrl)
      mtlLoader.setPath(options.mtlPath)
      mtlLoader.load(options.mtlFileName, function (materials) {
        materials.preload()
        var objLoader = new OBJLoader()
        objLoader.setMaterials(materials)
        objLoader.setPath(options.objPath)
        objLoader.load(options.objFileName, function (object) {
          if (typeof options.completeCallback === 'function') {
            options.completeCallback(object)
          }
        }, function (xhr) {
          if (xhr.lengthComputable) {
            var percentComplete = xhr.loaded / xhr.total * 100
            if (typeof options.progress === 'function') {
              options.progress(Math.round(percentComplete, 2))
            }
          }
        }, function () {

        })
      })
    },
    onWindowResize () {
      this.windowHalfX = window.innerWidth / 2
      this.windowHalfY = window.innerHeight / 2
      this.camera.aspect = window.innerWidth / window.innerHeight
      this.camera.updateProjectionMatrix()
      this.renderer.setSize(window.innerWidth, window.innerHeight)
    },
    onDocumentMouseMove (event) {
      this.mouseX = (event.clientX - this.windowHalfX) / 2
      this.mouseY = (event.clientY - this.windowHalfY) / 2
    },
    animate () {
      requestAnimationFrame(this.animate)
      this.render()
    },
    render () {
      // camera.position.x += ( mouseX - camera.position.x ) ;
      // camera.position.y += ( mouseY - camera.position.y ) ;
      this.camera.lookAt(this.scene.position)
      this.renderer.render(this.scene, this.camera)
    }
  }
}
</script>
